var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qty-box d-flex h-100" }, [
    _c("input", {
      ref: "quantityInputField",
      staticClass: "qty-input text-center",
      attrs: {
        type: "text",
        disabled: _vm.waiting || (_vm.isMaximum && _vm.isMinimum),
        "aria-label": _vm.$translate("Ceres::Template.itemQuantityInput")
      },
      domProps: { value: _vm.displayValue },
      on: {
        change: function($event) {
          return _vm.setValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "qty-btn-container d-flex flex-column" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMaximum && _vm.compMax !== 0,
              expression: "isMaximum && compMax !== 0"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: {
            disabled: _vm.isMaximum || _vm.waiting,
            "btn-appearance": _vm.useAppearance
          },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-testing": "quantity-btn-increase",
            title: _vm.maximumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputIncrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.increaseValue()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-plus default-float",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMinimum && _vm.compMax !== 0,
              expression: "isMinimum && compMax !== 0"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: {
            disabled: _vm.isMinimum || _vm.waiting,
            "btn-appearance": _vm.useAppearance
          },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "data-testing": "quantity-btn-decrease",
            title: _vm.minimumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputDecrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.decreaseValue()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-minus default-float",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }